export default __webpack_public_path__ + "static/media/SlideSix.d8a63a5f.png";